import type {} from '@redux-devtools/extension'; // required for devtools typing
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface FormStore<T> {
  formData: Partial<T>;
  setFormData: (data: Partial<T>) => void;
  reset: () => void;
}

export function createFormStore<T>(storeName: string) {
  return create<FormStore<T>>()(
    devtools(
      (set): FormStore<T> => ({
        formData: {},
        setFormData: data => {
          set(
            state => ({
              formData: {
                ...state.formData,
                ...data,
              },
            }),
            undefined,
            'setFormData',
          );
        },
        reset: () => {
          set({ formData: {} }, undefined, 'reset');
        },
      }),
      { name: storeName },
    ),
  );
}
